/** Mirrors web_api_server routes/v4/equipment-permissions.js. */
export const EQUIPMENT_PERMISSIONS = {
  read: 'equipment.read',
  write: 'equipment.write',
  review: 'equipment.review',
} as const;
